import * as React from 'react';
import styled from 'styled-components';
import { useQuery } from 'urql';

import Loader from '../../shared/components/Loader';
import { Gender } from '../../shared/types';
import Error from '../components/Error';
import Modal from '../components/Modal';
import Avatar from './Avatar';
import InfoSection from './InfoSection';
import PasswordForm from './PasswordForm';
import PictureForm from './PictureForm';
import PictureSection from './PictureSection';
import ProfileForm from './ProfileForm';

const query = `
    query {
        currentPerson {
            id
            firstName
            lastName
            gender
            title
            tel
            birthYear
            profilePicSrc
            noteForPlayer
            avatar
            avatarUrl(pose:"welcome")
            eMailNotifications
            user {
                email
            }
            organisation {
                id
                name
            }
            team {
                id
                name
            }
        }
    }
`;

export interface ICurrentPerson {
    id: string;
    firstName: string;
    lastName: string;
    gender: Gender;
    title: string;
    tel: string;
    birthYear: number | null;
    profilePicSrc: string | null;
    noteForPlayer: string | null;
    avatar: string;
    avatarUrl: string;
    eMailNotifications: boolean;
    user: {
        email: string;
    };
    organisation: {
        id: string;
        name: string;
    };
    team: {
        id: string;
        name: string;
    } | null;
}

interface IData {
    currentPerson: ICurrentPerson;
}

const Wrapper = styled.div`
    border: 1px solid lightgray;
    padding: 5px;
    min-height: 300px;
    flex-grow: 1;
    @media (min-width: 400px) {
        padding: 10px;
    }
    @media (min-width: 600px) {
        padding: 15px;
    }
`;

function Profile(): JSX.Element {
    const [result] = useQuery<IData>({
        query,
        requestPolicy: 'network-only',
    });

    if (result.fetching) {
        return <Loader />;
    } else if (result.error) {
        return <Error />;
    }

    const person = result.data.currentPerson;
    return <Wrapper>
        <InfoSection person={person} />
        <PictureSection person={person} />
        <ProfileForm person={person} />
        <Modal modal='Profile/ChangeAvatar'>
            <Avatar />
        </Modal>
        <Modal modal='Profile/ChangePassword'>
            <PasswordForm />
        </Modal>
        <Modal modal='Profile/ChangeProfilePicture'>
            <PictureForm />
        </Modal>
    </Wrapper>;
}

export default Profile;
